import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFondueLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 112,
	height: 24,
	viewBox: "0 0 112 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_432_8712)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_432_8712",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 112,
			height: 24,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M111.1 0H0.233398V24H111.1V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_432_8712)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M8.60006 1.86667C7.60006 3.36667 7.53339 5.73333 7.53339 10.6H0.233398V23.6667H1.4334C5.36673 23.6667 7.53339 23.6667 8.80006 21.8C9.83339 20.2667 9.93339 17.9 9.93339 12.9667H17.1334V0H15.7667C11.9667 0 9.86673 0 8.60006 1.86667ZM6.83339 20.4667C6.36673 21.1333 5.16673 21.2667 2.6334 21.2667V13H7.53339C7.53339 17.0667 7.46673 19.5333 6.83339 20.4667ZM14.7334 10.6H9.93339C9.93339 6.56667 10.0001 4.13333 10.6001 3.2C11.0334 2.53333 12.2334 2.43333 14.7001 2.4V10.6H14.7334Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.3332 8.03331H28.3999V5.63331C28.3999 4.69998 28.6999 4.36665 29.6666 4.36665H33.1332V1.76666H28.6999C26.4999 1.76666 25.3666 2.86666 25.3666 5.06665V8.03331H21.8999V10.6H25.3666V23.7H28.3666V10.6H32.3332V8.03331Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.5668 7.73334C35.3001 7.73334 31.9668 11.0333 31.9668 15.8666C31.9668 20.7333 35.3001 24 39.5668 24C43.8335 24 47.1668 20.7 47.1668 15.8666C47.1668 11 43.8335 7.73334 39.5668 7.73334ZM39.7001 21.5H39.4335C36.8668 21.5 34.9668 19.4666 34.9668 15.8666C34.9668 12.2666 36.8668 10.2333 39.4335 10.2333H39.7001C42.2668 10.2333 44.1668 12.2666 44.1668 15.8666C44.1668 19.4666 42.2668 21.5 39.7001 21.5Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M56.9666 7.73334C54.4332 7.73334 52.8666 8.83334 51.8999 10.2333V8.03334H48.8999V23.7H51.8999V14.9333C51.8999 11.9667 53.9666 10.2333 56.1999 10.2333H56.4666C58.6999 10.2333 59.6666 11.6333 59.6666 13.8333V23.7H62.6666V13.2C62.6332 9.89997 60.5999 7.73334 56.9666 7.73334Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76.2999 10.2333C75.4999 8.83335 73.5999 7.73335 71.3999 7.73335C67.4333 7.73335 64.2666 10.7 64.2666 15.8666C64.2666 21.0333 67.0999 24 71.0666 24C73.2666 24 75.4999 22.9 76.2999 21.5V23.7H79.2999V1.76666H76.2999V10.2333ZM71.8333 21.5H71.5666C69.1666 21.5 67.2666 19.6333 67.2666 15.8666C67.2666 12.1 69.1666 10.2333 71.5666 10.2333H71.8333C74.0666 10.2333 76.2999 12.1 76.2999 15.8666C76.2999 19.6333 74.0666 21.5 71.8333 21.5Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M92.267 16.5C92.267 19.6333 90.3003 21.5 88.267 21.5H88.0003C85.8336 21.5 84.8003 20.2333 84.8003 17.7333V8.03333H81.8003V18.3667C81.8003 21.6667 83.6336 24 87.167 24C89.9336 24 91.6336 22.4333 92.2336 20.7V23.6667H95.2336V8H92.2336V16.5H92.267Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M111.1 14.6C111.1 10.5333 108.5 7.70001 104.4 7.70001C100.667 7.70001 97.0332 10.4 97.0332 15.8C97.0332 21.2667 100.567 23.9667 104.5 23.9667C107.767 23.9667 110.5 22.1667 111.067 19.0333H108.067C107.767 20.7 106.267 21.4667 104.7 21.4667H104.433C102.5 21.4667 100.2 19.8667 99.9999 16.3H111.067V14.6H111.1ZM100.2 14C100.767 11.2 102.6 10.2333 104.267 10.2333H104.533C106.333 10.2333 107.967 11.2667 108.1 14H100.2Z",
					fill: "white"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_432_8712",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 111.333,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgFondueLogo;
